(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["edx-hoi-be"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__edxZaloTrack) return;
    window.__edxZaloTrack = true;
    var ask = document.querySelector('[data-edx-ask]');
    var nguon = ask ? ask.getAttribute('data-nguon') : 'blog';
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href*="zalo.me"]') : null;
      if (!a) return;
      var src = a.getAttribute('data-edx-zalo') || nguon;
      var be = a.getAttribute('data-edx-be') || '';
      try { if (typeof fbq === 'function') fbq('trackCustom', 'click_zalo', { source: 'blog', article: src, be: be }); } catch (err) {}
      try { if (typeof gtag === 'function') gtag('event', 'click_zalo', { source: 'blog', article: src, be: be }); } catch (err) {}
      try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'click_zalo', source: 'blog', article: src, be: be }); } catch (err) {}
    }, { passive: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["edx-muc-luc"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('[data-edx-toc]').forEach(function (root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      var min = parseInt(root.dataset.min || '2', 10);
      var content = document.querySelector('.blog-post-content, .rte, article') || document;
      var heads = Array.prototype.slice.call(content.querySelectorAll('h2'));
      heads = heads.filter(function (h) { return !root.contains(h) && h.textContent.trim().length > 0; });
      if (heads.length < min) { root.setAttribute('data-empty', ''); return; }
      heads.forEach(function (h, i) { if (!h.id) h.id = 'muc-' + (i + 1); });
      var lists = root.querySelectorAll('[data-edx-toc-list]');
      lists.forEach(function (ol) {
        ol.innerHTML = '';
        heads.forEach(function (h) {
          var li = document.createElement('li'); var a = document.createElement('a');
          a.href = '#' + h.id; a.textContent = h.textContent.trim(); a.dataset.target = h.id;
          a.addEventListener('click', function (e) { e.preventDefault(); h.scrollIntoView({ behavior: 'smooth', block: 'start' }); closeSheet(); });
          li.appendChild(a); ol.appendChild(li);
        });
      });
      var cnt = root.querySelector('[data-edx-toc-count]'); if (cnt) cnt.textContent = heads.length;
      var sticky = root.querySelector('[data-edx-toc-sticky]');
      var sheet = sticky && sticky.querySelector('.edx-toc__sheet');
      var openBtn = root.querySelector('[data-edx-toc-open]');
      var aside = root.querySelector('[data-edx-toc-aside]');
      var section = root.closest('[id^="shopify-section"]') || root.parentElement;
      var shift = 0;
      function closeSheet() { if (sheet) { sheet.hidden = true; openBtn && openBtn.setAttribute('aria-expanded', 'false'); } }
      if (openBtn) openBtn.addEventListener('click', function () { var open = sheet.hidden; sheet.hidden = !open; openBtn.setAttribute('aria-expanded', open ? 'true' : 'false'); });
      var bars = root.querySelectorAll('[data-edx-toc-progress]');
      var first = heads[0]; var last = content.querySelector('.edx-ask, .edx-faq') || heads[heads.length - 1];
      /* Mọi tính toán dùng vị trí thật trên màn hình (getBoundingClientRect), không dùng window.scrollY, vì Horizon cuộn trong .page-wrapper. */
      function update() {
        var active = null;
        heads.forEach(function (h) { if (h.getBoundingClientRect().top <= 120) active = h.id; });
        root.querySelectorAll('[data-edx-toc-list] a').forEach(function (a) { a.classList.toggle('is-active', a.dataset.target === active); });
        var firstTop = first.getBoundingClientRect().top;
        var lastTop = last.getBoundingClientRect().top;
        var started = firstTop < 200;
        var span = Math.max(1, lastTop - firstTop + 200);
        var p = Math.max(0, Math.min(1, (200 - firstTop) / span));
        bars.forEach(function (b) { b.style.width = (p * 100).toFixed(1) + '%'; });
        if (sticky) {
          var show = started && lastTop > 0 && window.innerWidth < 990;
          sticky.classList.toggle('is-visible', show);
          document.body.classList.toggle('edx-toc-has-bar', show);
          if (!show) closeSheet();
        }
        if (aside && window.innerWidth >= 990) {
          var secBottom = section.getBoundingClientRect().bottom;
          var r = aside.getBoundingClientRect();
          var h = r.bottom - r.top;
          var naturalBottom = r.bottom - shift;
          var over = naturalBottom + 24 - secBottom;
          shift = over > 0 ? -over : 0;
          aside.style.transform = shift ? 'translateY(' + shift + 'px)' : '';
          var hide = h > 0 && (naturalBottom + shift) < h * 0.4;
          aside.style.opacity = hide ? '0' : '';
          aside.style.pointerEvents = hide ? 'none' : '';
        } else if (aside) { aside.style.transform = ''; aside.style.opacity = ''; aside.style.pointerEvents = ''; shift = 0; }
      }
      var ticking = false;
      function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(function () { update(); ticking = false; }); } }
      document.addEventListener('scroll', onScroll, { passive: true, capture: true });
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', update);
      update();
      setTimeout(update, 600);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
